<script>
import VueTypes from 'vue-types'
import { mapGetters, mapActions } from 'vuex'
import HoverElement from '../HoverElement'

export default {
  name: 'SettingRadio',
  components: { HoverElement },
  props: {
    setting: VueTypes.string.isRequired,
    label: VueTypes.string.def(''),
    disabled: VueTypes.bool.def(false),
    options: VueTypes.array
  },
  computed: {
    ...mapGetters('LiveSetting', ['newSettings'])
  },
  methods: {
    ...mapActions('LiveSetting', ['updateNewSetting']),
    updateSettings (setting, value) {
      this.updateNewSetting({ setting, value })
      this.$emit('change', value)
    }
  }
}
</script>

<template lang="pug" src="./SettingRadio.pug"></template>
<style lang="scss" scoped>
label {
  margin-bottom: 0;
}
</style>
